module.exports = __webpack_public_path__ + "static/img/maintenance.a497020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maintenance.png
// module id = RacM
// module chunks = 1